module.exports = __webpack_public_path__ + "img/logo-25.ee6d588.jpg";